import React from 'react';

export default function DrawerBinderTabs({
  active,
  exercises = [],
  onWorkout,
  onExercise,
  rtl = false,
}) {
  const workoutLabel = rtl ? 'תרגילים' : 'Exercises';
  const edgeSide = rtl
    ? 'rounded-r-md border-l-0'
    : 'rounded-l-md border-r-0';
  const textSide = rtl
    ? '[writing-mode:vertical-rl]'
    : '[writing-mode:vertical-rl] rotate-180';

  const edgeBase =
    `w-10 max-h-[7.5rem] min-h-[4.5rem] py-2.5 px-1 text-[11px] font-semibold tracking-wide overflow-hidden border border-line dark:border-line-dark outline-none focus-visible:ring-2 focus-visible:ring-forest transition-colors duration-120 ${edgeSide}`;
  const stripBase =
    'shrink-0 max-w-[9rem] min-h-11 px-3 text-[12px] font-semibold truncate rounded-md border border-line dark:border-line-dark outline-none focus-visible:ring-2 focus-visible:ring-forest transition-colors duration-120';

  const selected = (id) =>
    active === id
      ? 'bg-surface dark:bg-surface-dark text-ink dark:text-ink-dark'
      : 'bg-canvas dark:bg-canvas-dark text-ink-muted hover:text-ink dark:hover:text-ink-dark';

  const leaves = [
    { id: 'workout', label: workoutLabel, onClick: onWorkout },
    ...exercises.map((ex) => ({
      id: ex.id,
      label: ex.label || (rtl ? 'תרגיל' : 'Exercise'),
      onClick: () => onExercise(ex.id),
    })),
  ];

  return (
    <>
      <div className="sm:hidden flex gap-1 px-4 pt-3 overflow-x-auto custom-scrollbar" role="tablist" aria-label={rtl ? 'דפי המגירה' : 'Drawer pages'}>
        {leaves.map((leaf) => (
          <button
            key={leaf.id}
            type="button"
            role="tab"
            aria-selected={active === leaf.id}
            title={leaf.label}
            onClick={leaf.onClick}
            className={`${stripBase} ${selected(leaf.id)}`}
          >
            {leaf.label}
          </button>
        ))}
      </div>

      <div
        dir="ltr"
        className={`hidden sm:flex absolute top-24 bottom-16 ${rtl ? '-right-10' : '-left-10'} flex-col gap-1 z-20 overflow-y-auto custom-scrollbar`}
        role="tablist"
        aria-label={rtl ? 'דפי המגירה' : 'Drawer pages'}
      >
        {leaves.map((leaf) => (
          <button
            key={leaf.id}
            type="button"
            role="tab"
            aria-selected={active === leaf.id}
            title={leaf.label}
            onClick={leaf.onClick}
            className={`${edgeBase} ${selected(leaf.id)}`}
          >
            <span dir={rtl ? 'rtl' : 'ltr'} className={`inline-block max-h-full overflow-hidden ${textSide}`}>
              {leaf.label}
            </span>
          </button>
        ))}
      </div>
    </>
  );
}
